export default "/images/Feline_full.svg?626e0f476c26d2beaf8b21cbc1d7fee9";